import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";
import CanonicalTag from "@/components/CanonicalTag";

const UDAWizardVideo = () => {
  useEffect(() => {
    // Add video structured data to this specific page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": "UDA ADU Wizard — Instantly Analyze Your Property",
      "description": "Discover your ADU potential in seconds: zoning, placement, design fit, and more. Try the UDA ADU Wizard for free.",
      "thumbnailUrl": "https://www.udaadu.com/uda-wizard-video-thumbnail.jpg",
      "uploadDate": "2025-06-14T00:00:00Z",
      "contentUrl": "https://wrghlmsinvhwvvfhhrvj.supabase.co/storage/v1/object/sign/VIDEOS/UDA%20ADU%20MAIN%20PAGE.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8zMWY3NTE2YS1mMTNjLTQ2MzEtYTliMC1mOWJmMGFjNTBkZjMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJWSURFT1MvVURBIEFEVSBNQUlOIFBBR0UubXA0IiwiaWF0IjoxNzQ5Njc1OTkzLCJleHAiOjIwNjUwMzU5OTN9.ZqXTGIc_jiNHFo-rqapg8iYsXVKNeOkJPj9lfkW6sjw",
      "embedUrl": "https://www.udaadu.com/uda-wizard-video",
      "duration": "PT3M45S"
    });
    document.head.appendChild(script);

    return () => {
      // Cleanup on unmount
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(s => {
        if (s.innerHTML.includes('UDA ADU Wizard — Instantly Analyze Your Property')) {
          s.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/uda-wizard-video" />
      <Navigation />
      
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              UDA ADU Wizard — Instantly Analyze Your Property
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Discover your ADU potential in seconds: zoning, placement, design fit, and more. Try the UDA ADU Wizard for free.
            </p>
          </div>

          {/* Video Player */}
          <div className="relative w-full max-w-4xl mx-auto mb-8">
            <div className="aspect-video bg-black rounded-lg overflow-hidden">
              <video 
                controls 
                className="w-full h-full"
                poster="/uda-wizard-video-thumbnail.jpg"
              >
                <source 
                  src="https://wrghlmsinvhwvvfhhrvj.supabase.co/storage/v1/object/sign/VIDEOS/UDA%20ADU%20MAIN%20PAGE.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8zMWY3NTE2YS1mMTNjLTQ2MzEtYTliMC1mOWJmMGFjNTBkZjMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJWSURFT1MvVURBIEFEVSBNQUlOIFBBR0UubXA0IiwiaWF0IjoxNzQ5Njc1OTkzLCJleHAiOjIwNjUwMzU5OTN9.ZqXTGIc_jiNHFo-rqapg8iYsXVKNeOkJPj9lfkW6sjw" 
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <a 
              href="/landing" 
              className="inline-block bg-[#E4683B] hover:bg-[#d55a32] text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-200"
            >
              Try UDA Wizard Now
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default UDAWizardVideo;